import {makeReactContext} from 'lib/makeReactContext';

/**
 * Informs the structured table (and its components) about the context the structured table is being created in.
 * For example, the structured table may be embedded in an entry that is embedded in a worksheet.
 * Depending on the creation context, the structured table may want to enable / disable specific functionality.
 *
 * The API ID of itemInsertedFromId is present when the structured table is embedded in the corresponding object.
 * (e.g. itemInsertedFromId is present and its value is a procedure API ID when the structured table is embedded in a procedure)
 */
export interface StructuredTableInsertionContextValue {
  itemInsertedFromId?: string;
  /** If inside a Procedure Execution, informs if the Worksheet is Multi-Batch. This is used to determine if
   * the Condition-Replicate column needs to be inserted into a Structured Table on insert. */
  isProcedureMultibatchExecution?: boolean;
}

const EMPTY_STRUCTURED_TABLE_INSERTION_CONTEXT: StructuredTableInsertionContextValue = {};

/**
 * An empty placeholder that opts out of any behaviors that depend on a StructuredTableInsertionContext.
 * @deprecated Use the context value provided by {@link StructuredTableInsertionContext} instead.
 */
export const EMPTY_PLACEHOLDER_INSERTION_CONTEXT = EMPTY_STRUCTURED_TABLE_INSERTION_CONTEXT;

export const StructuredTableInsertionContext = makeReactContext<StructuredTableInsertionContextValue>(
  () => EMPTY_STRUCTURED_TABLE_INSERTION_CONTEXT,
  'StructuredTableInsertionContext'
);
